<template>
  <div class="add-api x-padding" data-automation="addAPI">
    <div class="x-padding x-border-50 x-margin-b">
      <ux-steps :active="active + 1" align-center>
        <ux-step :title="$t('HT.addApi.title1')"></ux-step>
        <ux-step :title="$t('HT.addApi.title2')"></ux-step>
        <ux-step :title="$t('HT.addApi.title3')"></ux-step>
        <ux-step :title="$t('HT.addApi.title4')"></ux-step>
      </ux-steps>
    </div>
    <div class="content">
      <keep-alive>
        <component ref="from" :is="componentList[active]" :data="formData"></component>
      </keep-alive>
    </div>
    <div class="x-padding x-border-50 x-margin-b">
      <my-footer-btn
        :closeText="$t('HT.addApi.prevStep')"
        :confirmText="$t('HT.addApi.nextStep')"
        spacing="10px"
        padding="10px"
        @close="back"
        :hideClose="active === 0 ? true : false"
        :hideConfirm="active === 3 ? true : false"
        @confirm="confirm"
      >
        <el-button v-if="apiId || active == 3" type="primary" size="small" @click="save">{{
          $t('HT.save2')
        }}</el-button>
      </my-footer-btn>
    </div>
  </div>
</template>

<script>
import apiStepOne from './apiStepOne/apiStepOne.vue';
import apiStepTwo from './apiStepTwo/apiStepTwo.vue';
import apiStepThree from './apiStepThree/apiStepThree.vue';
import apiStepFour from './apiStepFour/apiStepFour.vue';
export default {
  components: {
    apiStepOne,
    apiStepTwo,
    apiStepThree,
    apiStepFour
  },
  data() {
    return {
      componentList: ['apiStepOne', 'apiStepTwo', 'apiStepThree', 'apiStepFour'],
      active: 0, // 步骤条索引
      formData: {
        // 最终提交参数
        group_id: '', // 所属分组
        name: '', // API名称
        protocol: '', // API协议
        remark: '', // 备注
        safety_certification: {
          type: '', //安全认证
          app_auth_type: null, //
          app_auth_param_name: null, //AppCode对应的参数名
          api_type: null, //API类型ID
          client_id: null, //client_id
          client_secret: null, //client_secret
          token_name: null, //token对应的参数名
          sign_auth: null //参数签名认证
        },
        prevent_replay_attacks: false, //API配置
        request: {
          uri: '', // 请求Path
          method: '', // 请求方法
          transfer_type: '', // 传输模式
          body_type: null,
          protocol: null,
          parameters: [] // 请求参数集合
        },
        service: {
          type: '', // 服务类型
          url: null, // 请求地址
          path: null, // 请求路径
          method: null, // 请求办法
          timeout: null, //超时时间
          mock_result: null, // mock内容
          mock_http_status: null, // mock响应Http状态码
          service_parameters: [], // 请求参数集合
          fix_parameters: [] //固定参数集合
        },
        response: {
          content_type: '', // 响应Body类型
          succeeded: '', // 请求成功示例
          failed: '' // 请求失败示例
        }
      },
      array: [], // 比对数组
      apiId: this.$route.query.id // api id
    };
  },

  created() {
    this.isEdit();
  },

  methods: {
    /**
     * 是否编辑状态下
     * @param {Object} params 查询对象
     */
    isEdit() {
      if (this.apiId) {
        let bread = this.$store.state.login.breadData;
        bread[bread.length - 1]['name'] = this.$t('HT.addApi.editApi');
        this.$store.commit('saveBreadData', bread); // 保存面包屑数据
        this.getInfo(this.apiId);
      }
    },

    /**
     * 上一步
     */
    back() {
      this.active--;
    },

    /**
     * 下一步
     */
    confirm() {
      this.$refs['from'].confirm().then((res) => {
        if (this.active === 0) {
          this.formData = res;
        }
        if (this.active === 1) {
          this.formData.request = res;
          if (JSON.stringify(this.array) !== JSON.stringify(res.parameters)) {
            this.formData.service.service_parameters = JSON.parse(
              JSON.stringify(res.parameters || [])
            );
          }
        }
        if (this.active === 2) {
          this.formData.service = res;
        }
        this.active++;
      });
    },

    /**
     * 保存
     */
    save() {
      this.$refs['from'].confirm().then((res) => {
        if (this.active === 1) {
          this.formData.protocol = res.protocol;
          if (JSON.stringify(this.array) !== JSON.stringify(res.parameters)) {
            let list = [];
            for (let i = 0; i < res.parameters.length; i++) {
              const item = res.parameters[i];
              list.push({
                default_value: item['default_value'],
                example: item['example'],
                index: item['index'],
                mapping_name: item['name'],
                mapping_position: item['position'],
                name: item['name'],
                position: item['position'],
                remark: item['remark'],
                required: item['required'],
                sort_num: item['sort_num'],
                type: item['type']
              });
            }
            this.formData.service.service_parameters = list;
          }
        }
        if (this.apiId) {
          this.putList(this.apiId, this.formData);
        } else {
          this.formData.protocol = this.formData.request.protocol;
          this.addList(this.formData);
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.api.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.$router.push('/apiList');
        }
      });
    },

    /**
     * 修改列表
     * @param {Number} id 唯一标识
     * @param {Object} params 表单提交参数
     */
    putList(id, params) {
      this.$uxLoading.show();
      this.$api.api.putList(id, params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          this.$router.push('/apiList');
        }
      });
    },

    /**
     * 获取详情
     * @param {String} id 唯一标识
     */
    getInfo(id) {
      this.$uxLoading.show();
      this.$api.api.getInfo(id).then((res) => {
        if (res.code == 10000) {
          this.formData = res.data;
          // this.array = JSON.parse(JSON.stringify(res.data.request.parameters));
        }
      });
    }
  }
};
</script>
